import $ from 'jquery';
import _ from 'lodash';
import QuantityTextField from "./../quantityTextField";
import React from "react";
import uuid from "uuid";
import * as Misc from "./../../misc";
import StonesStore from "./../../stores/stonesStore";
import ProjectScope from "./projectScope";
import ActionTypes from "./../../actionTypes";
import Config from "./../../config";
import FeatureBox from './featureBox';
import Analytics from './../../analytics';

export default class FeatureSelectionView extends React.Component {
  constructor(props) {
    super(props);

    const features = StonesStore.featuresByFabricatorAndGroupName(this.props.groupName, ProjectScope.quote());
    let mainFeature = _.first(features);
    const isIndividual = mainFeature.flags && _.some(mainFeature.flags, function (f) {
        return f === 'i';
      });
    const individualFeatures = {};
    _.each(ProjectScope.quote().features, function (v, k) {
      individualFeatures[k] = v;
    });
    let mixedQuantityTypes = false;
    let units = [];
    _.each(features, f => {
      if(units.indexOf(f.unit) == -1) {
        const qFlag = _.find(f.flags, function (fl) {
          return fl.indexOf('q') !== -1;
        });
        if(!qFlag) {
          units.push(f.unit);
        }
      }
    });
    if(units.length > 1) {
      mixedQuantityTypes = units.indexOf('No Quantity') >= 0;
    }
    
    this.state = {
      mainFeature: mainFeature,
      features: features,
      isRound: /edge[s]*\s*profile/i.test(this.props.groupName) || /faucet[s]*/i.test(this.props.groupName),
      isIndividual: isIndividual,
      quote: ProjectScope.quote(),
      individualFeatures: individualFeatures,
      value: Math.random(),
      parentNode: null,
      mixedQuantityTypes,
      hasFocusedFeauture: false,
      quoteEdges: [] // storing Edges for KV
    };
  }

  componentDidMount() {
    this.state.parentNode = $(this.refs.container).parent();
    $(this.refs.container)
        .detach()
        .appendTo(".main-wrapper")
        .find('.lightbox-wrapper')
        .hide();

    if((navigator.userAgent.match(/iPhone/i)) || (navigator.userAgent.match(/iPod/i)) || (navigator.userAgent.match(/iPad/i))) {
      $(this.refs.container).find('.lightbox-wrapper').show();
    } else {
      $(this.refs.container).find('.lightbox-wrapper').slideDown(600);
    }

    //$(document).on(ActionTypes.OVERLAY_CLICK, this.handleOverlayClick);
  }

  componentWillUnmount() {
    $(this.refs.container).detach().appendTo(this.state.parentNode);
  }

  toggleFocusedFeauture = (focused) => {
    this.setState({
        hasFocusedFeauture: focused
    })
  };

  saveAndClose = () => {
    ProjectScope.updateFeaturesQuantities(this.state.features.map(function (f) {
      return f.id;
    }), this.state.individualFeatures, null, this.state.quoteEdges);
    this.props.close(false);
  };

  handleOverlayClick = (e, data) => {
    this.saveAndClose();
  };

  handleSaveClick = (e) => {
    Analytics.sendClickEvent('overlay-save-button');
    Misc.ignoreDefault(e);

    this.saveAndClose();
  };

  handleCancelClick = (e) => {
    Analytics.sendClickEvent('overlay-cancel-button');
    Misc.ignoreDefault(e);
    this.props.close(true);
  };

  handleFeatureClick = (feature) => {
    Analytics.sendClickEvent('project-scope-lightbox-feature-selected: ' + feature.displayName);
    let quantity = 0;
    const qFlag = _.find(feature.flags, function (f) {
      return f.indexOf('q') !== -1;
    });
    if (qFlag) {
      quantity = parseInt(qFlag.substring(1));
    } else {
      quantity = 1;
    }
  
    let individualFeatures = {...this.state.individualFeatures};
    if(individualFeatures[feature.id]) {
      delete individualFeatures[feature.id];
    } else {
      individualFeatures[feature.id] = quantity;
    }
    
    this.setState({individualFeatures}, () => {
      if(!this.state.mixedQuantityTypes && this.props.firstEntry) {
        this.saveAndClose()
      }
    });
  };

  handleFeatureValueChanged = (feature, value) => {
    Analytics.sendDataEnteredEvent('project-scope-lightbox-feature-value-updated: ' + feature.displayName);
    const individualFeatures = this.state.individualFeatures;
    // console.log('feature', feature);
    // console.log('individualFeatures', individualFeatures);
    individualFeatures[feature.id] = value;
    if (/edge[s]*\s*profile/i.test(feature.name)) {
      const existingEdgeIndex = this.state.quoteEdges.findIndex((quoteEdge) => {
        return quoteEdge.id === feature.id
      });
      if (existingEdgeIndex >= 0) {
        this.state.quoteEdges[existingEdgeIndex].value = value;
      } else {
        this.state.quoteEdges.push({
          id: feature.id,
          value
        });
      }
    }
    this.setState({
      individualFeatures,
      quoteEdges: this.state.quoteEdges
    });
  };

  handleGlobalClick = (e) => {
    Analytics.sendClickEvent('overlay-lightbox');
    Misc.ignoreDefault(e);
    $(document).trigger(ActionTypes.OVERLAY_CLICK, {sender: 'lightbox-wrapper'});
  };

  handleSqftClick = (feature) => (e) => {
    // this.handleSaveClick();
    Misc.ignoreDefault(e);
    this.saveAndClose();
    this.props.showSquareFootCalc(feature);
    window.frames.sqftcalc.postMessage({action: `showSqft-${feature}`}, location.href);
  };

  render() {
    var anyQuantity = false;
    for(var i = 0; i < this.state.features.length && !anyQuantity; i++) {
      var feat = this.state.features[i];
      if(_.trim(feat.unit).toLowerCase() != "no quantity") {
        anyQuantity = true;
      }
    }

    let description = Config.featureDescription(this.props.groupName);
    let fgm = StonesStore.getFeatureGroupMeta(this.props.groupName.trim());
    let groupName = this.props.groupName;
    if(fgm) {
      if(fgm.customDisplayName && fgm.customDisplayName.length > 0) {
        groupName = fgm.customDisplayName;
      }
      if(fgm.customDescription && fgm.customDescription.length > 0) {
        description = fgm.customDescription;
      }
    }

    return (
      <div className="lightbox-container" ref="container" onClick={this.handleSaveClick}>
        <div className="lightbox-wrapper" onClick={this.handleGlobalClick}>
          <div className="lightbox-header-container">
            <div className="lightbox-title-block">
              <h7>{groupName}</h7>
              <p dangerouslySetInnerHTML={{__html: description}}>

              </p>
            </div>
            <div className="lightbox-fixed-block"/>
            <div className="lightbox-button-block">

              {anyQuantity || this.state.isIndividual || this.state.mixedQuantityTypes || !this.props.firstEntry ? (
                <div className="lightbox-save-button" onClick={this.handleSaveClick}>Save</div>
              ) : null}

              <div className="lightbox-cancel-button" onClick={this.handleCancelClick}>Close</div>
            </div>
          </div>
          <div className="lightbox-options-wrapper">
            {this.renderItems()}
            {(this.props.groupName === "Edge Profile") && (
              <button className="lightbox-options-button" onClick={this.handleSqftClick("edge")}>Help Calculate</button>
            )}
            {(this.props.groupName === "Radius") && (
              <button className="lightbox-options-button" onClick={this.handleSqftClick("radius")}>Help Calculate</button>
            )}
          </div>
        </div>
      </div>);
  }

  renderItems = () => {
    const currentFeatures = _.keys(this.state.quote.features).map(function (strId) {
      return parseInt(strId);
    });

    return this.state.features.map((f) => {
      return (
        <FeatureBox key={f.id} currentFeatures={currentFeatures} feature={f} isIndividual={this.state.isIndividual}
                    toggleFocusedFeauture={this.toggleFocusedFeauture} hasFocusedFeauture={this.state.hasFocusedFeauture}
                    click={this.handleFeatureClick} valueChanged={this.handleFeatureValueChanged}
                    isRound={this.state.isRound} isMixedUnitTypes={this.state.mixedQuantityTypes}/>);
    });
  }
};




// WEBPACK FOOTER //
// ./src/components/projectScope/featureSelectionView.js